import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';

export const serveCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('serve')
    .description(t('serve_command_def.description'))
    .action(async (_, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { ServeCommandDeprecated } = await import(
        '../components/ServeCommand/index.js'
      );
      await renderCommand(command, services, <ServeCommandDeprecated />);
    });
};
